// @codekit-prepend "forms/_input-select.js";
// @codekit-prepend "forms/_input-text.js";
// @codekit-prepend "forms/_input-textarea.js";"
// @codekit-prepend "forms/_input-file.js";
// @codekit-prepend "forms/_input-radio.js";
// @codekit-prepend "forms/_input-checkbox.js";
// @codekit-prepend "forms/_input-range-slider.js";

/* Forms - Placeholders */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsPlaceholders() {
    
    /* No Placeholder */
    if ( jQuery( 'html' ).hasClass( 'platform-no-placeholder' ) ) {
        
        /* Loop Form Elements */
        jQuery( 'input, textarea' ).each(function( index ) {

            /* Check Placeholder */
            if ( jQuery( this ).attr( 'placeholder' ) ) {

                /* Set Placeholder */
                if ( jQuery( this ).val() == '' ) {
                    jQuery( this ).val( jQuery( this ).attr( 'placeholder' ) ).addClass( 'form-placeholder' );
                }

                /* Focus */
                jQuery( this ).on( 'focus' , function() {
                    if ( jQuery( this ).val() == jQuery( this ).attr( 'placeholder' ) ) {
                        jQuery( this ).val( '' ).removeClass( 'form-placeholder' );
                    }
                });
                
                /* Blur */
                jQuery( this ).on( 'blur' , function() {
                    if ( jQuery( this ).val() == '' ) {
                        jQuery( this ).val( jQuery( this ).attr( 'placeholder' ) ).addClass( 'form-placeholder' );
                    }
                });

            }

        }); 
    
    }

}

/* Forms - Label */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsStyleLabel( element ) {
    
    /* If Label */
    if ( element.data( 'label' ) !== undefined && element.data( 'label' ) ) {
        
        /* Check For ID */
        if ( element.attr( 'id' ) === undefined || element.attr( 'id' ) == '' ) {
            
            /* If Name Add ID */
            if ( element.attr( 'name' ) !== undefined && element.attr( 'name' ) != '' ) {
                element.attr( 'id' , element.attr( 'name' ) );
            }
    
        }
        
        /* Add Label */
        if ( element.attr( 'id' ) !== undefined && element.attr( 'id' ) != '' ) {
            element.parent().prepend( '<label for="' + element.attr( 'id' ) + '">' + element.data( 'label' ) + '</label>' );
        }
    
    }

}

/* Forms - IE10 Fix */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsIE10Fix() {

    /* IE 10 Form Fix */
	if ( jQuery( 'html').hasClass( 'browser-ie10' ) ) {
        jQuery( 'input[type=text] , textarea' ).each(function( index ) {
            if ( jQuery( this ).val() != '' ) {
                var value = jQuery( this ).val();
                jQuery( this ).val( '' ).val( value );
            }
        });
	}

}

/* Forms - Disabled Element */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsStyleDisabled( element ) {
    
    //setTimeout(function() {    

    /* If Validation */
    if ( element.data( 'disabled' ) !== undefined && element.data( 'disabled' ) == 'disabled' ) {
        
        /* Disable Element */
        ipcrimeFormsDisable( element );
    
    }
    
    //} , 10 );

}

/* Forms - Disable Element */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsDisable( element ) {

    /* Button */
    if ( element.hasClass( 'form-button' ) ) {
        
        /* If Button */
        if ( element.is( 'button' ) ) {
            
            /* Disable */
            element.prop( 'disabled' , true );
        
        }
        
        /* Add Class */
        element.addClass( 'disabled' );
    
    /* Form Element */
    } else if ( element.is( 'select' ) || element.is( ':text' ) || element.is( ':password' ) || element.is( ':file' ) || element.is( 'textarea' ) || element.is( ':radio' ) || element.is( ':checkbox' ) ) {

        /* Disable */
        element.prop( 'disabled' , true );
        
        /* Add Class */
        element.parent().addClass( 'disabled' );
    
    /* Container */
    } else if ( element.find( 'select, :text, :password, :file, textarea, :radio, :checkbox' ).length ) {

        /* Disable Input */
        element.find( 'select, :text, :password, :file, textarea , :radio, :checkbox' ).prop( 'disabled' , true );
        
        /* Add Class */
        element.addClass( 'disabled' );
    
    /* Dropzone */
    } else if ( element.hasClass( 'form-file' ) && element.find( '.dz-clickable' ).length ) {
        
        /* Add Class */
        element.addClass( 'disabled' );
        
    }

}

/* Forms - Enable Element */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsEnable( element ) {

    /* Button */
    if ( element.hasClass( 'form-button' ) ) {
        
        /* If Button */
        if ( element.is( 'button' ) ) {
            
            /* Disable */
            element.prop( 'disabled' , false );
        
        }
        
        /* Remove Class */
        element.removeClass( 'disabled' );
    
    /* Form Element */
    } else if ( element.is( 'select' ) || element.is( ':text' ) || element.is( ':password' ) || element.is( ':file' ) || element.is( 'textarea' ) || element.is( ':radio' ) || element.is( ':checkbox' ) ) {
        
        /* Disable */
        element.prop( 'disabled' , false );
        
        /* Remove Class */
        element.parent().removeClass( 'disabled' );
    
    /* Container */
    } else if ( element.find( 'select, :text, :password, :file, textarea , :radio, :checkbox' ) ) {
        
        /* Enable Input */
        element.find( 'select, :text, :password, :file, textarea , :radio, :checkbox' ).prop( 'disabled' , false );
        
        /* Remove Class */
        element.removeClass( 'disabled' );
    
    /* Dropzone */
    } else if ( element.hasClass( 'form-file' ) && element.find( '.dz-clickable' ).length ) {
        
        /* Remove Class */
        element.removeClass( 'disabled' );
        
    }

}

/* Validation - Add Validation Mark To Element */
/* ------------------------------------------------------------------------------------------------ */
function ipcrimeFormsValidateElementMark( element ) {
    
    /* Check Element */
    if ( element.is( ':text' ) || element.is( ':password' ) || element.is( 'textarea' ) || element.is( 'select' ) ) {
            
        /* Get Label */
        var label = element.prev( 'label' );
        
        /* If Label */
        if ( label.length ) {
        
            /* Add Mark */
            label.append( '<span> *</span>' );
        
        }
    
    } else if ( element.is( ':radio' ) || element.is( ':checkbox' ) ) {
        
        /* Add Mark */
        element.parent().append( '<span> *</span>' );
    
    }

}

/* Validation - Add Validation To Element */
/* ------------------------------------------------------------------------------------------------ */
function ipcrimeFormsValidateElement( element ) {

    /* If Validation */
    if ( element.data( 'validation' ) !== undefined && element.data( 'validation' ) ) {
        
        /* Load Rules Into Array */
        var rules = element.data( 'validation' ).split( '|' );
        
        /* Loop Rules */
        jQuery.each( rules , function( index , value ) {
            
            /* Required */
            if ( value.indexOf( 'required' ) > -1 ) {
                element.rules( 'add' , { required: true } );
                element.addClass( 'form-validated' );
                ipcrimeFormsValidateElementMark( element );
            }
            
            /* Email */
            if ( value.indexOf( 'email' ) > -1 && element.is( ':text' ) ) {
                element.rules( 'add' , { email: true } );
                element.addClass( 'form-validated' );
            }
            
            /* Max Length */
            if ( value.indexOf( 'minlength' ) > -1 && ( element.is( ':text' ) || element.is( ':password' ) || element.is( 'textarea' ) ) ) {
                element.rules( 'add' , { minlength: value.replace( 'minlength:' , '' ) } );
                element.addClass( 'form-validated' );
            }
            
            /* Simple Phone */
            if ( value.indexOf( 'simplephone' ) > -1 && element.is( ':text' ) ) {
                element.rules( 'add' , { simplephone: true } );
                element.addClass( 'form-validated' );
            }
            
            /* International Phone */
            if ( value.indexOf( 'intlPhone' ) > -1 && element.is( ':text' ) ) {
                element.rules( 'add' , { intlPhone: true } );
                element.addClass( 'form-validated' );
            }
            
            /* URL */
            if ( value.indexOf( 'simpleUrl' ) > -1 && element.is( ':text' ) ) {
                element.rules( 'add' , { simpleUrl: true } );
                element.addClass( 'form-validated' );
            }
            
        
        });
        
    }

}

/* Validation - Valid */
/* ------------------------------------------------------------------------------------------------ */
function ipcrimeFormsValidateFormErrorValid( element ) {

    /* Container */
    var container = element.parents( 'div , label' ).first();
    
    /* Remove Class */
    container.removeClass( 'form-error' );
    
    /* Find Error */
    container.find( 'p.form-error' ).remove();

}

/* Validation - Error */
/* ------------------------------------------------------------------------------------------------ */
function ipcrimeFormsValidateFormError( error , element ) {

    /* Container */
    var container = element.parents( 'div , label' ).first();
    
    /* Find Error */
    var containerError = container.find( 'p.form-error' );
    
    /* If Error */
    if ( containerError.length ) {
        
        /* Update Error */
        container.addClass( 'form-error' );
        containerError.html( error  );
        
    } else {
    
        /* Add Error */
        container.addClass( 'form-error' );
        container.append( '<p class="form-error">' + error + '</p>' );
    
    }

}

/* Forms - Add Validation */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsValidateForm( form ) {
    
    /* Check Form */
    if ( form.length ) {
    
        /* Start Validation */
        var validator = form.validate({
            
            /* No Validation */
            ignore: '.form-input-no-validation',
            
            /* No Focus */
            focusInvalid: false,
            
            /* Error Placement */
            errorPlacement: function( error , element ) {
                
                /* Call Function */
                ipcrimeFormsValidateFormError( error.html() , element );
            
            },
            
            /* Success Placement */
            success: function( error , element ) {
                
                /* Call Function */
                ipcrimeFormsValidateFormErrorValid( jQuery( element ) );
            
            }
        
        });
        
        /* Loop Form Elements */
        setTimeout(function() {
            form .find( '*[data-validation]' ).each(function( index ) {
            
                /* Get Element */
                var element = jQuery( this );
                
                /* Add Validation To Element */
                ipcrimeFormsValidateElement( element );
        
            });
        } , 1 );
        
        /* Focus Out */
        validator.settings.onfocusout = function( element ) {
            jQuery( element ).valid();
        };
    
    }

}

/* Forms - Extend Validation */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsValidateExtend() {

    /* Simple Phone */
    /* ------------------------------------------------------------------------------------------------ */
    jQuery.validator.addMethod( 'simplephone' , function( value , element ) {
        if ( ( value ) && ( value != '' ) ) {
            var regex = /^([0-9\(\)\/\+ \-]*)$/i;
            return regex.test( value );
        } else {
            return true;
        }
    
    }, 'Please enter a valid phone number' );
    
    /* International Phone Number */
    /* ------------------------------------------------------------------------------------------------ */
	jQuery.validator.addMethod('intlPhone', function(value) { 
		return (value.match(/^((\+)?[1-9]{1,2})?([-\s\.])?((\(\d{1,4}\))|\d{1,4})(([-\s\.])?[0-9]{1,12}){1,2}(\s*(ext|x)\s*\.?:?\s*([0-9]+))?$/)); 
	}, 'Please enter a valid phone number');
	
	/* url 
	/* ------------------------------------------------------------------------------------------------ */
	
	
	jQuery.validator.addMethod('simpleUrl', function(value) { 
		return (value.match(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/)); 
	}, 'Please enter a valid url');


}

/* Forms - Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsInit( callback ) {
    
    /* Select */
    ipcrimeFormsSelectInit();
    
    /* Text */
    ipcrimeFormsTextInit();
    
    /* Textarea */
    ipcrimeFormsTextareaInit();
    
    /* Radio */
    ipcrimeFormsRadioInit();
    
    /* Checkbox */
    ipcrimeFormsCheckboxInit();
    
    /* Forms - File */
    ipcrimeFormsFileInit();
    
    /* Setup Placeholders */
    ipcrimeFormsPlaceholders();
    
    /* IE10 Fix */
    ipcrimeFormsIE10Fix();
    
    /* Extend Validation */
    ipcrimeFormsValidateExtend();
    
    /* Validate Form */
    jQuery( 'form' ).each(function( index ) {
        ipcrimeFormsValidateForm( jQuery( this ) );
    });
    
    /* Fire Callback */
    if ( typeof (callback) === 'function' ) {
        callback();
    }
    
}